<app-header></app-header>

<div id="bet-success">

  <div class="section full">
    <div class="section-title justify-content-center">
      <div *ngIf="status == 'success'" class="text-center">
        <img src="assets/img/common/check-icon.png" alt="">
        <h3 class="text-success">{{ 'bet_success' | translate}}</h3>
      </div>
      <div *ngIf="status !='success'" class="text-center">
        <img src="assets/img/common/incorrect.png" alt="">
        <h3 class="text-danger">{{ 'bet_unsuccess' | translate}}</h3>
      </div>
    </div>
  </div>
  <div class="section full mt-5">
    <div class="section-title justify-content-center">
      <button type="button" class="btn done-btn" (click)="openHomePage()" style="white-space: nowrap;">
        {{ 'bet_done' | translate }}
      </button>
    </div>
  </div>

</div> <!-- end of bet-success -->